import * as React from 'react';
import { CoreProps } from '../types';
import styles from './pin.module.scss';

export interface PinAllowedStyles {
    top?: string | number;
    right?: string | number;
    bottom?: string | number;
    left?: string | number;
    transform?: string;
    zIndex?: number;
}
type PinProps = {
    as?: keyof JSX.IntrinsicElements;
    hidden?: boolean;
    xy?: PinAllowedStyles;
    /** A style object with constraints */
} & CoreProps;

export const Pin = ({ xy = {}, as: Tag = 'div', children, composeClassName = undefined, className = undefined, hidden }: PinProps) => {
    const clss = [styles.absolute, composeClassName, className].filter(Boolean).join(' ');

    return (
        <Tag className={clss} style={xy} aria-hidden={hidden ? 'true' : 'false'}>
            {children}
        </Tag>
    );
};

Pin.Centered = (props: PinProps) => <Pin {...props} composeClassName={styles.center} />;
Pin.Cover = (props: PinProps) => <Pin {...props} composeClassName={styles.cover} />;
